/**
 * instanceCounter
 *
 *  ...for tracking and logging
 *
 */
'use strict';

import Utils from '../HlsUtils';

/**
* @access internal
*/
class InstanceCounter {

	constructor(config = {} ) {
		this._lastNumber = 0;
		this._totalActive = 0;

		Utils.applyConfig(this, config);
	}


	dispose() {
	}


	//increment active and last number, return new last number
	increment() {
		this._lastNumber++;
		this._totalActive++;

		return this._lastNumber;
	}


	//decrement active total, return new value
	decrement() {
		this._totalActive--;
		return this._totalActive;
	}


	//return active total
	active() {
		return this._totalActive;
	}


	//return last number, which is the same as the total count given
	total() {
		return this._lastNumber;
	}
}
export default InstanceCounter;



// WEBPACK FOOTER //
// ./src/utils/instanceCounter.js